import React from 'react';
import { motion } from 'framer-motion';

function Experience() {
    // Sample experience data
    const experiences = [
        {
            date: 'Jun 2022 - July 2022',
            title: 'Software Engineering Intern',
            company: 'Personifyw',
            description: 'Developed and maintained web applications using React and Node.js. Collaborated with cross-functional teams to define and implement new features.'
        },
        {
            date: 'May 2024 - August 2024',
            title: 'Contributor',
            company: 'Circuitverse',
            description: 'Developing a simulator version control system for circuits that are made on different versions, enabling backward compatibility of the circuits.'
        }
    ];

    // Function to render individual experience entry
    const renderExperience = (experience, index) => (
        <motion.div
            key={index}
            className={`flex flex-col lg:flex-row items-center mt-8 ${index % 2 === 0 ? 'lg:flex-row-reverse' : ''}`}
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: index * 0.2 }}
            viewport={{ once: true }}
        >
            <div className="lg:w-1/2 lg:pl-8">
                <div className="bg-white dark:bg-gray-800 shadow-lg rounded-lg p-6 lg:ml-8">
                    <h2 className="text-xl font-semibold dark:text-gray-300">{experience.title}</h2>
                    <h3 className="text-md font-medium text-gray-600 dark:text-gray-300">{experience.company}</h3>
                    <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">{experience.date}</p>
                    <p className="mt-2 text-gray-600 dark:text-gray-300">{experience.description}</p>
                </div>
            </div>
            <div className="lg:w-1/2 flex items-center justify-center relative">
                <div className="w-1 h-full bg-blue-500 absolute left-1/2 transform -translate-x-1/2"></div>
                <div className={`hidden lg:block h-6 bg-blue-500 absolute ${index % 2 === 0 ? 'left-0' : 'right-0'}`}></div>
            </div>
        </motion.div>
    );

    return (
        <section id="experience">
            <div className="container px-6 py-10 mx-auto">
                <motion.h1
                    className="text-2xl font-semibold text-center capitalize lg:text-3xl dark:text-white"
                    initial={{ opacity: 0, y: -50 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6 }}
                >
                    Experience
                </motion.h1>
                <div className="relative mt-10">
                    <div className="hidden lg:block absolute w-1 bg-blue-500 left-[52.5%] transform -translate-x-1/2 h-full"></div>
                    {experiences.map((experience, index) => renderExperience(experience, index))}
                </div>
            </div>
        </section>
    );
}

export default Experience;